module.exports = __webpack_public_path__ + "img/icon-config.a8776f91.svg";